var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembershipCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / crown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 633283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M8 10.2965L3.8623 5.84602C3.17506 5.10684 2 5.63036 2 6.67572L2.5 14.5L8 10.2965Z",
    fill: "#60A6E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    d: "M8 10.2965L12.1377 5.84602C12.8249 5.10684 14 5.63036 14 6.67572L13.5 14.5L8 10.2965Z",
    fill: "#1890FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3177",
    d: "M6.98694 3.89451C7.36567 2.99932 8.63433 2.99932 9.01306 3.89451L13.5 14.5H2.5L6.98694 3.89451Z",
    fill: "#81BDF5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1690",
    cx: 14,
    cy: 4,
    r: 1.25,
    fill: "#1890FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1692",
    cx: 8,
    cy: 1.5,
    r: 1.25,
    fill: "#81BDF5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1691",
    cx: 2,
    cy: 4,
    r: 1.25,
    fill: "#60A6E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipCrown);
export default __webpack_public_path__ + "static/media/membership-crown.033837377a4d7b16bf78592edd42bcc3.svg";
export { ForwardRef as ReactComponent };